import { createFileRoute } from "@tanstack/react-router";
import IntroToKetamineTherapyPage from "@/pages/articles/IntroToKetamineTherapyPage";
export const Route = createFileRoute(
  "/intro-to-ketamine-therapy-coral-springs-fl",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Intro to Ketamine Therapy in Coral Springs, FL | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "Discover how IV Ketamine therapy and SPRAVATO® rapidly alleviate treatment-resistant depression and PTSD in Coral Springs, FL. Fast-acting glutamate.",
        },
        {
          property: "og:title",
          content:
            "Intro to Ketamine Therapy in Coral Springs, FL | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "Discover how IV Ketamine therapy and SPRAVATO® rapidly alleviate treatment-resistant depression and PTSD in Coral Springs, FL. Fast-acting glutamate.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/intro-to-ketamine-therapy-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/intro-to-ketamine-therapy-coral-springs-fl",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <IntroToKetamineTherapyPage />;
}
